// var configEnv = "development";
// var configEnv = "staging";
// var configEnv = "production";

var configEnv = process.env.REACT_APP_NODE_ENV;
if (!["development", "staging", "production"].includes(configEnv)) {
  throw new Error(`Invalid REACT_APP_NODE_ENV value: ${configEnv}`);
}

var config = {
  //##########Live config##########
  production: {
    appUrl: "https://winnabull.com",
    apiUrl: "https://api.winnabull.com/api/v1",
    staticUrl: "https://ranchmaster39.winnabull.com/public",
    liveChatUrl: "https://ranchmaster39.winnabull.com/public/livechat/php/app.php?widget-inline",
    FBAppId: "1172568450039492",
    GoogleClientId: "918922690152-tk90kb6fiq5ssekf7fcnn2d3hfrkvkkv.apps.googleusercontent.com",
    debug: false,
  },

  //#########Stage config##########
  staging: {
    appUrl: "https://winnabull.cbstagings.com",
    apiUrl: "https://winnabullapi.cbstagings.com/api/v1",
    staticUrl: "https://winnabullapi.cbstagings.com/api/v1",
    publicDir: "https://winnabullboss.cbstagings.com/public",
    liveChatUrl: "https://winnabullboss.cbstagings.com/public/livechat/php/app.php?widget-inline",
    FBAppId: "1172568450039492",
    GoogleClientId: "918922690152-tk90kb6fiq5ssekf7fcnn2d3hfrkvkkv.apps.googleusercontent.com",
    debug: false,
  },

  //##########Local config##########
  development: {
    appUrl: "http://front.casino.local:3000",
    apiUrl: "http://api.casino.local:8002/api/v1",
    staticUrl: "http://api.casino.local:8002/api/v1",
    liveChatUrl: "http://livechat.casino.local:8003/php/app.php?widget-inline",
    fileSourceUrl: "http://admin.casino.local:8001/public",
    debug: true,
  },
};

var finalConfig = config[configEnv];

finalConfig.defaultLanguage = {
  code: "en",
  language: "English",
  flag_path: finalConfig.fileSourceUrl + "/images/flags/svg/gb.svg",
};

export default finalConfig;

// export default config[configEnv];
